import { getContactChangeSyncStatusViews } from '../../../apps/professional-app/fa/MeetingSummary/ExternalUpdates/utils'
import { useAppSelector } from '../../../store/hooks'
import { selectContactChanges } from '../../../store/meetingSummary/contactUpdate'
import { selectDocumentSummarySyncStatus } from '../../../store/processDocument/document'
import { selectDocumentBatchContact } from '../../../store/processDocument/documentBatch'
import { unifyDocumentSyncStatuses } from './utils'

export const useDocumentSyncStatuses = () => {
  const documentSummarySyncStatus = useAppSelector(selectDocumentSummarySyncStatus)
  const contactChanges = useAppSelector(selectContactChanges)
  const contact = useAppSelector(selectDocumentBatchContact)

  const contactChangesSyncStatuses = getContactChangeSyncStatusViews(contactChanges, contact ? [contact] : [])

  const syncStatus = unifyDocumentSyncStatuses(documentSummarySyncStatus, contactChangesSyncStatuses)

  const sortedSyncStatus = syncStatus.sort((a, b) => Date.parse(b.syncedAt) - Date.parse(a.syncedAt))

  return {
    syncStatuses: sortedSyncStatus,
    documentSummarySyncStatuses: sortedSyncStatus.filter(({ type }) => type === 'documentSummary'),
    contactUpdateSyncStatuses: sortedSyncStatus.filter(({ type }) => type === 'updateContact'),
    contactCreateSyncStatuses: sortedSyncStatus.filter(({ type }) => type === 'createContact'),
  }
}
